import React from 'react';
import tw from 'twin.macro';
import ButtonLink from '@teetsh/app/src/components/Buttons/Link';
import Button from '@teetsh/app/src/components/Buttons/Button';

interface HomeConfig {
  to?: string;
  onClick?: () => void;
  icon?: React.ReactNode | (() => React.ReactNode);
  text?: string;
  ariaLabel?: string;
  alwaysShowText?: boolean;
}

interface Props {
  home: HomeConfig;
  hasVisibleItems: boolean;
}

export function BreadcrumbHomeButton({ home, hasVisibleItems }: Props) {
  const textSpanStyles = [
    tw`text-neutral-moderate text-sm font-normal ml-2`,
    !home.alwaysShowText && tw`truncate`,
    !home.alwaysShowText && !hasVisibleItems && tw`hidden lg:block`,
    !home.alwaysShowText && hasVisibleItems && tw`hidden`,
  ];

  if (home.to) {
    return (
      <ButtonLink
        to={home.to}
        minimal
        tw="px-1"
        icon={home.icon as any}
        aria-label={home.ariaLabel}
      >
        {home.text && <span css={textSpanStyles}>{home.text}</span>}
      </ButtonLink>
    );
  }

  if (home.onClick) {
    return (
      <Button
        onClick={home.onClick}
        minimal
        tw="px-1"
        icon={home.icon as any}
        aria-label={home.ariaLabel}
      >
        {home.text && <span css={textSpanStyles}>{home.text}</span>}
      </Button>
    );
  }

  return null;
}
